/**
 * אפסים מובילים בשדות מספר — הגנה גלובלית.
 *
 * שדה <input type="number"> מבוקר שמציג 0, ומקלידים בו אחרי האפס, מקבל
 * מהדפדפן את הערך "010000". React מעדכן את ה-DOM רק כשהערך שונה מספרית
 * (node.value != value), ו-"010000" == 10000, ולכן האפס נשאר על המסך
 * אף שהמצב עצמו נכון. זה קרה בבורר הביטחונות ויכול לקרות בכל שדה
 * מספרי שמציג 0 — ולכן ההגנה כאן ולא בכל שדה בנפרד.
 *
 * ההאזנה רצה בשלב ה-capture על document, כלומר לפני המאזינים של React
 * שיושבים על שורש האפליקציה. הערך נכתב דרך ה-setter המקורי של
 * HTMLInputElement ולא דרך node.value: React עוטף את node.value במעקב
 * משלו, וכתיבה דרכו הייתה גורמת לו לחשוב שאין שינוי ולבלוע את onChange.
 */
export function installNumberInputGuard(doc = typeof document === "undefined" ? null : document) {
  if (!doc || doc.__numberInputGuard) return;
  doc.__numberInputGuard = true;
  const proto = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, "value");
  if (!proto?.set) return;
  doc.addEventListener("input", (e) => {
    const el = e.target;
    if (!(el instanceof HTMLInputElement) || el.type !== "number") return;
    const v = el.value;
    if (!/^-?0\d/.test(v)) return;
    proto.set.call(el, v.replace(/^(-?)0+(?=\d)/, "$1"));
  }, true);
}
